{
  "title": "STARFALL SALVAGE",
  "rulesheet": [
    "Hit Contract Board. Cargo Bay accepts the selected job. Launch Rail refuels.",
    "Complete jobs to earn ranks. Three jobs on one ball qualify Leviathan Approach.",
    "Open Hull, lock two balls, then Cargo Bay for multiball. Admiral + Approach light Leviathan."
  ],
  "illustration": {
    "asset": "starfall-original",
    "tile": 3
  },
  "lighting": {
    "version": 1,
    "rubber": "#393D41",
    "environment": [
      "#F1D4A1",
      "#1A2025",
      "#434A4D",
      "#38D6D1",
      "#E0AB63",
      "#B9C6CA"
    ],
    "palette": {
      "idle": "#DEC699",
      "active": "#38D6D1",
      "hit": "#F3FFFF",
      "award": "#FFD36B"
    },
    "modes": {
      "debrisSweep": "#38D6D1",
      "fuelRun": "#38D6D1",
      "beaconHunt": "#38D6D1",
      "towJob": "#38D6D1",
      "asteroidBreaker": "#38D6D1",
      "airlockRelay": "#38D6D1",
      "spinUp": "#38D6D1",
      "tractorTest": "#38D6D1",
      "scavAmbush": "#E25735",
      "radiationLeak": "#E25735",
      "hullBreach": "#38D6D1",
      "lostCrew": "#38D6D1",
      "gateRun": "#38D6D1",
      "blackBox": "#38D6D1",
      "beltCollapse": "#38D6D1",
      "salvageLock": "#FFD36B",
      "asteroidStorm": "#FFD36B",
      "rivalRun": "#E25735",
      "beltSweep": "#38D6D1",
      "leviathan": "#FFD36B"
    },
    "cues": {
      "jackpot": "jackpot",
      "multiball": "multiball",
      "contractComplete": "bank",
      "beltSweep": "combo"
    },
    "paths": {
      "launchRail": "fuel1",
      "launchReturn": "fuel1",
      "jumpGate": "jumpArrow",
      "jumpReturn": "jumpArrow"
    }
  }
}
